import React from 'react';
import { motion } from 'framer-motion';
import { styles } from '../../styles'
import { services } from '../../components/constants/index';
import { fadeIn, textVariant } from '../utils/motion';
import { SectionWrapper } from '../../components/hoc';


interface Service {
  title: string;
  icon: string;
}

interface ServiceCardProps {
  index: number;
  title: string;
  icon: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ index, title, icon }) => {
  return (
    <motion.div
      variants={fadeIn('right', 'spring', 0.5 * index, 0.75)}
      className="xs:w-[250px] w-full card-gradient p-[1px] rounded-[20px] shadow-card"
    >
      <div
        data-options={{
          max: 45,
          scale: 1,
          speed: 450,
        }}
        className="bg-jetLight rounded-[20px] py-5 px-12 min-h-[280px] flex justify-evenly items-center flex-col"
      >
        <img src={icon} alt={title} className="w-16 h-16 object-contain" />
        <h3 className="text-taupe text-[18px] font-bold text-center">{title}</h3>
      </div>
    </motion.div>
  );
};

const Availabledoc: React.FC = () => {
  return (
    <div className="-mt-[6rem]">
      <motion.div variants={textVariant()}>
        <p className={styles.sectionSubText}>Introduction</p>
        <h2 className={styles.sectionHeadText}>Overview.</h2>
      </motion.div>

      <motion.p
        variants={fadeIn('', '', 0.1, 1)}
        className="mt-4 text-taupe text-[18px] max-w-3xl leading-[30px]"
      >
        Welcome to our Hospital app's doctor page, where you can access a network of highly skilled and experienced medical professionals right at your fingertips. Our app is designed to streamline the healthcare experience, connecting patients with the best doctors in their area and providing convenient tools for managing appointments, accessing medical records, and seeking expert medical advice.
      </motion.p>

      <div className="mt-20 flex flex-wrap gap-10">
        {services.map((service: Service, index: number) => (
          <ServiceCard key={service.title} index={index} {...service} />
        ))}
      </div>
    </div>
  );
};

export default SectionWrapper(Availabledoc, 'availabledoc');